import '.a{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.a1{justify-content:center;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.cp{background:var(--shades-white);}.ssr-plugin'
import '.c1{flex-grow:1;}.ssr-plugin'
import '.k{align-items:center;}.ssr-plugin'
import '.b8{max-width:77.5rem;}.ssr-plugin'
import '.dc{justify-content:stretch;}.ssr-plugin'
import '.dd{position:sticky;}.ssr-plugin'
import '.cj{top:0;}.ssr-plugin'
import '.de{z-index:10;}.ssr-plugin'
import '.df{padding-block:1rem;}.ssr-plugin'
import '.dg{height:3rem;}.ssr-plugin'
import '.p{justify-content:space-between;}.ssr-plugin'
import '.dh{flex-wrap:wrap;}.ssr-plugin'
import '.di{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.b6{margin-top:2rem;}.ssr-plugin'
import '.dj{padding-bottom:6rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const PlotRegistryPageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ab a1 b cp"
      >
        <div className="c1 a k a1 b"
        >
          <div className="b8 a b dc dd cj de cp"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="df dg a p k dh"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="di a b ab b6 dj b8"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
